// stores
import platform from '@/stores/platform.js'

export default {
  computed: {
    // retrieve the curriculums
    curriculums () {
      return platform.getters.getCurriculums || []
    },

    // retrieve the exercises
    exercises () {
      return platform.getters.getExercises || []
    },

    // retrieve the list of open questions
    questions () {
      return platform.getters.getQuestions || []
    },

    // retrieve the instructors
    instructors () {
      return platform.getters.getInstructors || []
    },

    // retrieve the open threads
    threads () {
      return platform.getters.getThreads || []
    }
  },

  methods: {
    /*
     * Retrieve the category of an exercise based on its UUID
     */
    getExercise (uuid) {
      return this.exercises.filter(e => e.uuid === uuid)[0] || null
    },

    /*
     * Retrieve an exercise's title
     */
    getExerciseTitle (uuid) {
      var e = this.getExercise(uuid)

      if (!e) {
        return null
      }

      return e.title
    },

    /*
     * Retrieve the email address of a given instructor uid
     */
    getInstructorEmail (uid) {
      var res = this.instructors.filter(i => i.id === uid)

      if (!res || !res.length) {
        return null
      }

      return res[0].email
    }
  }
}